const isClientAvailable = (client) => client?.isOfflineSelectable === true;

export const shouldEnableSideMenuEnterSelection = ({
  searchTerm,
  isSearchFocused,
} = {}) => {
  if (!isSearchFocused) return false;
  if (typeof searchTerm !== "string") return false;
  return searchTerm.trim().length > 0;
};

export const resolveSideMenuEnterTargetClient = ({
  clients,
  selectedClientId,
} = {}) => {
  if (!Array.isArray(clients) || clients.length === 0) {
    return null;
  }

  const firstAvailableClient = clients.find(isClientAvailable) || null;
  if (!firstAvailableClient) {
    return null;
  }

  if (firstAvailableClient.id && firstAvailableClient.id === selectedClientId) {
    return null;
  }

  return firstAvailableClient;
};

